import React, { Component } from 'react';
import Icon from 'components/Icon/Icon.react';
import styles from './DropDown.scss';

export default class DropDown extends Component {
  constructor(props) {
    super();
    this.state = {
      open: false,
    }

    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.handleKey = this.handleKey.bind(this);
  }

  componentDidMount() {
    document.addEventListener('keydown', this.handleKey);
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKey);
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  handleKey(e) {
    var keyCode = e.keyCode || e.which;
    switch (keyCode) {
      case 27:
        this.setState({ open: false });
        break;
    }
  }

  handleClickOutside(event) {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.setState({ open: false });
    }
  }

  toggleClick() {
    this.setState((state) => {
      return {
        open: !state.open,
      }
    });
  }

  render() {
    const { items, type } = this.props;
    const classes = [styles.container];
    if(type === 'toolbar') {
      classes.push(styles.toolbar);
    }

    const tutorials = items.tutorials;
    const videos = items.videos;
    const js_docs = items.js_docs;
    const rest_docs = items.rest_docs;
    const android_docs = items.android_docs;
    const ios_docs = items.ios_docs;
    const github = items.github;

    return (
      <div className={classes.join(' ')} ref={this.setWrapperRef}>
        <div className={[styles.btn, this.state.open ? styles.open : '' ].join(' ')}>
          <span onClick={() => this.toggleClick()}>Tutorials &amp; Docs</span>
          <ul className={styles.dropdown}>
            { tutorials && <li><a href={tutorials} target="_blank" rel="noreferrer noopener">Tutorials</a></li> }
            { videos && <li><a href={videos} target="_blank" rel="noreferrer noopener">Videos</a></li> }
            { js_docs && <li><a href={js_docs} target="_blank" rel="noreferrer noopener">JavaScript Docs.</a></li> }
            { rest_docs && <li><a href={rest_docs} target="_blank" rel="noreferrer noopener">REST Docs.</a></li> }
            { android_docs && <li><a href={android_docs} target="_blank" rel="noreferrer noopener">Android Docs.</a></li> }
            { ios_docs && <li><a href={ios_docs} target="_blank" rel="noreferrer noopener">iOS Docs.</a></li> }
            { github && <li><a href={github} target="_blank" rel="noreferrer noopener">Code Examples</a></li> }
          </ul>
        </div>
      </div>
    );
  }
}
